import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { isMobile, isBrowser } from 'react-device-detect';
import trackerItemText from './trackerItemText';
import { popUpEnum } from './trackerEnum';
import { replaceVariablesInBrackets, handleURL } from '../../../utilities/StringHelpers/StringHelpers';
import gaParams from '../../../utilities/analytics/constants';
import { gaEvent } from '../../../utilities/analytics/tracking';
import Helper from '../../../utilities/analytics/helper';
import { setActiveLobbyTab, setStartedFromTracker } from '../../Block/CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import { lobbyTabsEnum } from '../../Block/CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import { connect } from 'react-redux';
import Config from '../../../Config';
import './tracker.scss';

const TrackerPopUp = (props) => {
  const { saveAs } = require('file-saver');
  const ics = require('ics');

  const actionIcons = {
    addToCalendar: require('./images/vector-smart-object-copy-11.svg'),
    deleteMessage: require('./images/vector-smart-object-copy-10.svg'),
    editVisit: require('./images/vector-smart-object-copy-4.svg'),
  };
  const text = trackerItemText;

  const openUrl = (el) => {
    if (typeof el.url === 'object' && el.url !== null) {
      gaEvent(
        gaParams.PERSONAL_AREA_CLICK_TRACKER_POPUP.category,
        gaParams.PERSONAL_AREA_CLICK_TRACKER_POPUP.eventType,
        Helper.objToString({ popUpType: props.popUpType, action: 'addToCalendar' }, gaParams.PERSONAL_AREA_CLICK_TRACKER_POPUP.eventParams)
      );
      ics.createEvent(el.url, (error, value) => {
        if (error) {
          return;
        }
        var file = new File([value], 'event.ics', { type: 'text/calendar' });
        saveAs(file);
      });
    } else {
      gaEvent(
        gaParams.PERSONAL_AREA_CLICK_TRACKER_POPUP.category,
        gaParams.PERSONAL_AREA_CLICK_TRACKER_POPUP.eventType,
        Helper.objToString({ popUpType: props.popUpType, action: 'editAction' }, gaParams.PERSONAL_AREA_CLICK_TRACKER_POPUP.eventParams)
      );
      if (props.clearCache) props.clearCache(props.popUpType);
      props.navigateToPage(el.url);
    }
  };

  gaEvent(gaParams.PERSONAL_AREA_SHOW_TRACKER_POPUP.category, gaParams.PERSONAL_AREA_SHOW_TRACKER_POPUP.eventType, props.popUpType);

  if (props.popUpType === popUpEnum.MANAGERCALL) {
    let cancelUrl = props.URLs.managerCallCancel.value;

    let itemText = text.body.waitingForCall;

    let title = itemText.title.value;

    let desc = replaceVariablesInBrackets(itemText.text.value, props.openDate, props.callDate)
      .split('\n')
      .map((str, i) => <p key={i}>{str}</p>);

    let actions = {};

    const event = {
      start: props.addToCalendar,
      duration: props.duration,
      title: itemText.title,
      description: `שיחה חוזרת משירות ${window.Config.brand_Name_HE}`,
      location: '',
      status: 'CONFIRMED',
      busyStatus: 'BUSY',
    };

    actions['addToCalendar'] = {
      val: itemText.actions.addToCalendar.value,
      url: event,
    };

    actions['deleteMessage'] = props.canCancel === true ? { val: itemText.actions.deleteMessage.value, url: cancelUrl } : { val: false };

    return (
      <div className='tracker-popup'>
        <div className='tracker-popup-info' style={{ minWidth: Object.keys(actions).length > 0 && !isMobile ? '70%' : '100%' }}>
          <div className='tracker-popup-title'>{title}</div>
          <div className='tracker-popup-subtitle'>
            <div>{desc}</div>
          </div>
        </div>

        <div className='tracker-popup-actions'>
          {Object.entries(actions).map((el, i) => {
            if (el[1].val) {
              return (
                <div className='tracker-popup-action' key={i} onClick={() => openUrl(el[1])}>
                  <Image src={actionIcons[el[0]]} />
                  <div>{el[1].val}</div>
                </div>
              );
            }
          })}
        </div>
      </div>
    );
  }

  if (props.popUpType === popUpEnum.ABROAD_PACKAGE) {
    const title = 'יש לך חבילת חו"ל';
    const generalTxt = 'לניהול החבילה כנס לאזור חו"ל שלי';
    const phraseA = `למנוי ${props.subscriberNumber} יש חבילת חו\"ל בתוקף החל `;
    const phraseB = props.renderDates(props.abroadPackage.socEffactiveDate, props.abroadPackage.socExpDate);
    function goTo(subscriberNumber) {
      // TBD redirect to abroad lobby
      props.setActiveLobbyTab(lobbyTabsEnum.PACKAGEEXISTS);
      props.setStartedFromTracker(subscriberNumber);
      props.context.navigateTo(props.urlToAbroad);
    }

    return (
      <div className='tracker-popup'>
        <div className='tracker-popup-info' style={{ minWidth: isBrowser ? '70%' : '100%' }}>
          <div className='tracker-popup-title'>{title}</div>
          <div className='tracker-popup-subtitle'>{phraseA}</div>
          <div className='tracker-popup-subtitle'>{phraseB}</div>
          <div className='tracker-popup-subtitle'>{generalTxt}</div>
        </div>
        {/* <div className='tracker-popup-vertical-divider'></div> */}
        <div className='tracker-popup-actions'>
          <div className='tracker-popup-action' onClick={() => goTo(props.subscriberNumber)}>
            {/* <img src={actionIcons.editVisit}></img> */}
            <div>עבור לחבילה שלי</div>
          </div>
        </div>
      </div>
    );
  }

  if (props.popUpType === popUpEnum.TECHNICIANVISIT) {
    let cancelUrl = props.URLs.technicianVisitCancel.value;
    let updateUrl = props.URLs.technicianVisitUpdate.value;

    let itemText = text.body.technicianVisit;

    let type = `${window.Config.brand_Name_HE}`;
    if (props.isInfrastructure) {
      type = 'תשתית';
    }
    if (props.isFiber) {
      type = 'סופר פייבר';
    }

    let title = replaceVariablesInBrackets(itemText.title.value, type);

    let desc = replaceVariablesInBrackets(itemText.text.value, type)
      .split('\n')
      .map((str, i) => <p key={i}>{str}</p>);
    let superFiberDesc = itemText.superFiber.value.split('\n').map((str, i) => <p key={i}>{str}</p>);
    let dateTime = replaceVariablesInBrackets(itemText.dateTime.value, props.visitEndTime, props.visitStartTime, props.visitDate);
    let addressTitle = itemText.addressText.value;
    let address = props.address ? replaceVariablesInBrackets(itemText.address.value, props.address) : null;
    let specialText = itemText.specialText.value;

    let actions = {};

    const event = {
      start: props.addToCalendar,
      duration: props.duration,
      title: title,
      description: '',
      location: address,
      status: 'CONFIRMED',
      busyStatus: 'BUSY',
    };

    actions['addToCalendar'] = {
      val: itemText.actions.addToCalendar.value,
      url: event,
    };

    actions['editVisit'] = props.canEdit === true ? { val: itemText.actions.editVisit.value, url: updateUrl } : { val: false };

    actions['deleteMessage'] = props.canCancel === true ? { val: itemText.actions.deleteMessage.value, url: cancelUrl } : { val: false };

    return (
      <div className='tracker-popup'>
        <div className='tracker-popup-info' style={{ minWidth: Object.keys(actions).length > 0 && !isMobile ? '70%' : '100%' }}>
          <div className='tracker-popup-title'>{title}</div>
          <div className={'tracker-popup-subtitle' + (props.isFiber && isMobile ? ' superfiber' : '')}>
            {props.isFiber && <div className='tracker-popup-superfiber-desc'>{superFiberDesc}</div>}
            <div>{desc}</div>
          </div>
          <div className={'tracker-popup-date tracker-popup-subtitle' + (props.isFiber && isMobile ? ' superfiber' : '')}>{dateTime}</div>
          {address && (
            <>
              <div className={'tracker-popup-address tracker-popup-subtitle ' + (props.isFiber && isMobile ? ' superfiber' : '')}>
                {addressTitle}
              </div>
              <div className={'tracker-popup-address-value bold tracker-popup-subtitle' + (props.isFiber && isMobile ? ' superfiber' : '')}>
                {address}
              </div>
            </>
          )}

          <div className={'tracker-popup-specialtext tracker-popup-subtitle' + (props.isFiber && isMobile ? ' superfiber' : '')}>
            {specialText}
          </div>
        </div>

        <div className='tracker-popup-actions'>
          {Object.entries(actions).map((el, i) => {
            if (el[1].val) {
              return (
                <div className='tracker-popup-action' key={i} onClick={() => openUrl(el[1])}>
                  {/* <img src={actionIcons[el[0]]}></img> */}
                  <div>{el[1].val}</div>
                </div>
              );
            }
          })}
        </div>
      </div>
    );
  }

  if (props.popUpType === popUpEnum.REFUND) {
    let itemText = text.body.refund[props.refundStatus];

    let textAmountKey =
      props.amount === null || props.amount === '' || props.amount === undefined || props.amount === '0.00'
        ? 'textNoAmount'
        : 'textWithAmount';

    let title = itemText.title.value;
    let desc = replaceVariablesInBrackets(itemText.text[textAmountKey].value, props.dueDate, props.amount, props.inInvoiceDate)
      .split('\n')
      .map((str, i) => <p key={i}>{str}</p>);

    let actions = {};
    if (itemText['actions'] !== undefined) {
      for (const [key, el] of Object.entries(itemText['actions'])) {
        actions[key] = el;
      }
    }

    return (
      <div className='tracker-popup'>
        <div className='tracker-popup-info' style={{ minWidth: Object.keys(actions).length > 0 && !isMobile ? '70%' : '100%' }}>
          <div className='tracker-popup-title'>{title}</div>
          <div className='tracker-popup-subtitle'>
            <div>{props.dueDate != null && desc}</div>
          </div>
        </div>

        <div className='tracker-popup-actions'>
          {Object.keys(actions).map((el, i) => (
            <div className='tracker-popup-action' key={i}>
              <Image src={actionIcons[el]} />
              <span>{itemText.actions[el]}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (props.popUpType === popUpEnum.FOLLOWUPREFUND) {
    let itemText = trackerItemText.body.followUpRefund[props.refundStatus]; //props.refundStatus

    let textAmountKey = props.amount === null || props.amount === '' || props.amount === undefined ? 'textNoAmount' : 'textWithAmount';

    let title = itemText.title.value;

    let desc = replaceVariablesInBrackets(itemText.text[textAmountKey].value, props.dueDate, props.amount)
      .split('\n')
      .map((str, i) => <p key={i}>{str}</p>);

    let actions = {};
    if (itemText['actions'] !== undefined) {
      for (const [key, el] of Object.entries(itemText['actions'])) {
        actions[key] = el;
      }
    }

    return (
      <div className='tracker-popup'>
        <div className='tracker-popup-info' style={{ minWidth: Object.keys(actions).length > 0 && !isMobile ? '70%' : '100%' }}>
          <div className='tracker-popup-title'>{title}</div>
          <div className='tracker-popup-subtitle'>
            <div>{desc}</div>
          </div>
        </div>

        <div className='tracker-popup-actions'>
          {Object.keys(actions).map((el, i) => (
            <div className='tracker-popup-action' key={i}>
              <Image src={actionIcons[el]} />
              <div>{itemText.actions[el]}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (props.popUpType === popUpEnum.PLANCHANGE) {
    let itemText = text.body.changePricePlan[props.planChangeType];

    let title = itemText.title.value;

    let desc = replaceVariablesInBrackets(itemText.text.value, props.cellularNo, props.dueDate)
      .split('\n')
      .map((str, i) => <p key={i}>{str}</p>);

    let actions = {};
    if (itemText['actions'] !== undefined) {
      for (const [key, el] of Object.entries(itemText['actions'])) {
        actions[key] = el;
      }
    }

    return (
      <div className='tracker-popup'>
        <div className='tracker-popup-info' style={{ minWidth: Object.keys(actions).length > 0 && !isMobile ? '70%' : '100%' }}>
          <div className='tracker-popup-title'>{title}</div>
          <div className='tracker-popup-subtitle'>{desc}</div>
        </div>

        <div className='tracker-popup-actions'>
          {Object.keys(actions).map((el, i) => (
            <div className='tracker-popup-action' key={i}>
              <Image src={actionIcons[el]} />
              <div>{itemText.actions[el]}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (props.popUpType === popUpEnum.CUSTOMER_DEVLIVERIES) {
    const title = 'מתואמת לכם שליחות';
    const statusTxt = props.status;
    const questionFixedTxt = 'השליח יגיע אליכם בתאריך: ';
    const arrivalDayTxt = props?.deliverySlots[0]?.date;
    const arrivalTimeTxt = props?.deliverySlots[0]?.start + '-' + props?.deliverySlots[0]?.end;
    const arrivalDateTxt = arrivalTimeTxt + ' | ' + arrivalDayTxt;
    const addressFixedText = 'לכתובת';

    let itemText = text.body.customerDeliveries;

    let locationEvent = replaceVariablesInBrackets(itemText.calenderEventLocation.value, props.address);
    let calenderEventDesc = replaceVariablesInBrackets(
      itemText.calenderEventText.value,
      arrivalDayTxt,
      arrivalTimeTxt,
      props.address,
      Config.staticWebSiteUrl + props.contentData.customerDeliveriesLink.value.url
    );

    let actions = {};

    const event = {
      start: props.addToCalendar,
      duration: props.duration,
      title: itemText.calenderEventName.value,
      description: calenderEventDesc,
      location: locationEvent,
      status: 'CONFIRMED',
      busyStatus: 'BUSY',
    };

    actions['addToCalendar'] = {
      val: itemText.actions.addToCalendar.value,
      url: event,
    };

    actions['editVisit'] = {
      val: itemText.actions.editVisit.value,
      url: props.contentData.customerDeliveriesLink.value.url,
    };

    return (
      <div className='tracker-popup'>
        <div className='tracker-popup-info' style={{ minWidth: isBrowser ? '70%' : '100%' }}>
          <div className='tracker-popup-title'>{title}</div>
          <div className='tracker-popup-subtitle'>
            {/* {statusTxt}
            <br /> */}
            {questionFixedTxt}
            {arrivalDayTxt}
          </div>
          <div className='tracker-popup-subtitle'>{'בין השעות: ' + arrivalTimeTxt}</div>
          <div className='tracker-popup-subtitle'>
            {addressFixedText + ': '} {props.address}
          </div>
        </div>

        <div className='tracker-popup-actions'>
          <div className='tracker-popup-action' onClick={() => openUrl(actions['addToCalendar'])}>
            <div>צור תזכורת ביומן שלי</div>
          </div>
          <div className='tracker-popup-action' onClick={() => openUrl(actions['editVisit'])}>
            <div>עדכון מועד שליחות</div>
          </div>
        </div>
      </div>
    );
  }

  if (props.popUpType === popUpEnum.FINANCE_ISSUE) {
    const title = 'לתשומת ליבך,';
    const financeIssueType = props.banFinanceIssueType;
    let displayIssueText = '';

    if (financeIssueType === 'NoPaymentMethodAndDebtIssue') {
      displayIssueText = `עלייך לעדכן את אמצעי התשלום שלך ב${window.Config.brand_Name_HE} ולשלם את החוב.`;
    } else if (financeIssueType === 'NoPaymentMethod') {
      displayIssueText = `עלייך לעדכן את אמצעי התשלום שלך ב${window.Config.brand_Name_HE}.`;
    } else {
      displayIssueText = 'עלייך לשלם את החוב.';
    }

    return (
      <div className='tracker-popup'>
        <div className='tracker-popup-info' style={{ minWidth: isBrowser ? '70%' : '100%' }}>
          <div className='tracker-popup-title'>{title}</div>
          <div className='tracker-popup-subtitle'>
            <p>על פי רישומנו קיימת בעיה פיננסית באחד מחשבונותך.</p>
            <p>{displayIssueText}</p>
          </div>
        </div>
      </div>
    );
  }
};
// const mapStateToProps = (state) => {
//   return {
//     loginData: state.authentication?.loginData,
//   };
// };

const mapDispatchToProps = {
  setActiveLobbyTab,
  setStartedFromTracker,
};

export default connect(null, mapDispatchToProps)(TrackerPopUp);
